import { memo } from 'react';
import { ReplyEditor } from 'composer-ui/reply-editor/public/components';
import ResizableStyling from './ResizableStyling';
import { jsx as _jsx } from "react/jsx-runtime";
const ResizableReplyEditor = /*#__PURE__*/memo(props => {
  return /*#__PURE__*/_jsx(ResizableStyling, {
    threadId: props.threadId,
    editorFragment: props.editorFragment,
    trackEvent: props.trackEvent,
    children: /*#__PURE__*/_jsx(ReplyEditor, Object.assign({}, props))
  });
});
ResizableReplyEditor.displayName = 'ResizableReplyEditor';
export default ResizableReplyEditor;